import React from 'react';
import { useSelector } from 'react-redux';
import { styled } from 'styled-components';
import THEME from '../theme.js';
const SubscribedToCosmo = () => {
    const lang = useSelector((s) => s.lang);
    return (React.createElement("a", { style: {
            color: 'inherit',
            textDecoration: 'none',
        }, href: "https://debbie.dk/cosmo", target: "_blank", rel: "noreferrer" },
        React.createElement(Styled, { style: { marginTop: '10px' } },
            "COSMO ",
            React.createElement("small", null,
                "(",
                lang.misc.cosmoActivated,
                ")"))));
};
export default SubscribedToCosmo;
const Styled = styled.div `
  color: ${THEME.COLOR_SECONDARY};
  background-color: ${THEME.COLOR_ACCENT};
  padding: 3px 7px;
  border-radius: 15px;
  font-size: 0.7em;
  display: inline-block;
`;
//# sourceMappingURL=SubscribedToCosmo.js.map